import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';

interface IButtonProps {
    'data-testid'?: string;
    onClick: () => void;
    style?: any;
    disabled?: boolean;
    children: JSX.Element | JSX.Element[] | string | GenericLazyString;
}

const Button = ({
    'data-testid': dataTestId,
    style,
    onClick,
    disabled,
    children,
}: IButtonProps) => {
    let classes = 'eds-btn eds-btn--button eds-btn--neutral';

    if (style === 'fill') {
        classes = 'eds-btn eds-btn--button eds-btn--fill'; // eds-btn--icon-with-other-children
    }
    if (disabled) {
        classes = 'eds-btn eds-btn--button eds-btn--neutral eds-btn--disabled';
    }
    return (
        <button
            className={classes}
            onClick={onClick}
            disabled={disabled}
            type="button"
            data-testid={dataTestId}
        >
            {children}
        </button>
    );
};

export default Button;
